(function () {
  class ReadMoreText extends HTMLElement {

    connectedCallback() {
      this._content = this.querySelector('[data-read-more-content]');
      this._toggle = this.querySelector('[data-read-more-toggle]');

      if (!this._content || !this._toggle) return;

      this._labelMore = this._toggle.querySelector('[data-read-more-label="more"]');
      this._labelLess = this._toggle.querySelector('[data-read-more-label="less"]');

      this._clickHandler = this._handleToggleClick.bind(this);
      this._toggle.addEventListener('click', this._clickHandler);

      this._resizeHandler = this._debounce(this._measure.bind(this), 150);
      window.addEventListener('resize', this._resizeHandler);

      this._measure();
    }

    disconnectedCallback() {
      if (this._toggle) this._toggle.removeEventListener('click', this._clickHandler);
      window.removeEventListener('resize', this._resizeHandler);
    }

    _measure() {
      if (this.hasAttribute('open')) return;

      var lines = parseInt(this.getAttribute('lines'), 10) || 4;
      var lineHeight = this._getLineHeight(this._content);

      this._collapsedHeight = Math.round(lineHeight * lines);
      this._content.style.maxHeight = this._collapsedHeight + 'px';

      var hasOverflow = this._content.scrollHeight > this._collapsedHeight + 1;
      this.toggleAttribute('has-overflow', hasOverflow);
      this._toggle.hidden = !hasOverflow;
    }

    _getLineHeight(el) {
      var style = window.getComputedStyle(el);
      var lineHeight = parseFloat(style.lineHeight);

      if (!lineHeight || isNaN(lineHeight)) {
        lineHeight = parseFloat(style.fontSize) * 1.4;
      }

      return lineHeight;
    }

    _handleToggleClick() {
      var isOpen = this.hasAttribute('open');

      if (isOpen) {
        this._content.style.maxHeight = this._collapsedHeight + 'px';
        this.removeAttribute('open');
      } else {
        this._content.style.maxHeight = this._content.scrollHeight + 'px';
        this.setAttribute('open', '');
      }

      this._toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (this._labelMore) this._labelMore.hidden = !isOpen;
      if (this._labelLess) this._labelLess.hidden = isOpen;
    }

    _debounce(fn, wait) {
      var timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
      };
    }
  }

  if (!customElements.get('read-more-text')) {
    customElements.define('read-more-text', ReadMoreText);
  }
})();
